import AboutScreen from './components/AboutScreen'

export default {
  path: '/nosotros',
  component: AboutScreen,
  name: 'About'
}



// WEBPACK FOOTER //
// ./src/app/screens/About/index.js